import { Component, inject } from '@angular/core';

import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './footer-v2.component.html'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  private readonly footerRouter = inject(Router);

  scrollToSection(sectionId: string) {
    // About and Contact are standalone pages now (v3).
    if (sectionId === 'about' || sectionId === 'contact') {
      this.footerRouter.navigate(['/' + sectionId]);
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}

